import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import {
  approveSubmission,
  sendBackSubmission,
  markSubmissionsSeen,
  unapproveSubmission,
  type UnapproveSubmissionBody,
} from '@/api/managerSubmissions'
import { toast } from '@/stores/useToastStore'

export function useApproveSubmission() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: approveSubmission,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.manager.all })
      toast.success('Submission approved successfully')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to approve submission')
    },
  })
}

export function useSendBackSubmission() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: sendBackSubmission,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.manager.all })
      toast.success('Submission sent back to planner')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to send back submission')
    },
  })
}

export function useUnapproveSubmission() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      submissionId,
      body,
    }: {
      submissionId: string
      body?: UnapproveSubmissionBody
    }) => unapproveSubmission(submissionId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.manager.all })
      toast.success('Submission unapproved successfully')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to unapprove submission')
    },
  })
}

export function useMarkSubmissionsSeen() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: markSubmissionsSeen,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.manager.all })
    },
  })
}
